<app-modal [Modal]="{
    title: 'Empresas',
    closeTitle: true,
    hiddenFooter: true
}">
    <ng-container body>
        <div class="container__table">

            <mat-form-field>
                <mat-label>Filtro</mat-label>
                <input type="text" autocomplete="off" (keyup)="onFilter($event)" matInput placeholder="Buscar empresa">
                <mat-icon matSuffix class="iconSearch" style="color: #888888; margin-right: 8px;">search</mat-icon>
            </mat-form-field>

            <ng-container *ngIf="isLoading else _content">
                <div class="content__loading">
                    <mat-spinner [diameter]="80"></mat-spinner>
                </div>
            </ng-container>
            <ng-template #_content>
                <div class="responsive__table">
                    <table mat-table [dataSource]="appStateService.GetListcompany && appStateService.GetListcompany.companyList || []">

                        <ng-container matColumnDef="col1">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" (click)="selectEmpresa(element.company, element.companyName)" style="cursor: pointer; width: 90%;"> {{element.companyName}} </td>
                        </ng-container>

                        <ng-container matColumnDef="col2">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" (click)="selectEmpresa(element.company, element.companyName)">
                                <mat-icon style="color: #888888; cursor: pointer;">chevron_right</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="2">
                                <div class="not__found">
                                    <div class="container__img">
                                        <img src="assets/media/svg/buscar.svg">
                                    </div>
                                    <div class="container-label">
                                        <p>No hemos encontrado ningún resultado que coincida con tu búsqueda</p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </ng-template>
            <div>
                <mat-paginator #paginator [length]="totalItems" [pageSize]="itemsPerPage" (page)="getPaginatorData($event)"></mat-paginator>
            </div>
        </div>
    </ng-container>
</app-modal>